export class IndexedElementPool {
  constructor(tagName) {
    this._tagName = tagName;

    this._pool = [];
  }

  getElement(index) {
    let element = this._pool[index];
    if (!element) {
      element = document.createElement(this._tagName);
      this._pool[index] = element;
    }

    return element;
  }
}
